import { render, staticRenderFns } from "./TopDeals.vue?vue&type=template&id=1ce11f7a&scoped=true"
import script from "./TopDeals.vue?vue&type=script&lang=js"
export * from "./TopDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce11f7a",
  null
  
)

export default component.exports